import React from 'react';
import '../../cssFiles/footer.scss';

const Footer = () => (
  <footer className="nvz-footer">
    <div className="nvz-footer-main">
      <div className="nvz-footer-title">
        SEBI (Research Analyst) Regulations 2014, Registration No. <span className="nvz-footer-bold">INH000002558</span>.
      </div>
      <div className="nvz-footer-desc">
        At Niveza India Pvt Ltd., we all come to work everyday to take the challenges of stock market head on and to change people's perception that stock market investment is like a gamble. Over the years, we have built our profile as a company which has brought optimum value to our subscribers through our well-researched stock recommendations. We don’t promise you unrealistic returns, we don’t chase intraday or F&O dreams. We believe in the ideals of value & growth investment; these values are reflected in our products. We are always marching ahead with the goal to better ourselves.
      </div>
      <div className="nvz-footer-disclaimer">
        <span className="nvz-footer-disclaimer-title">Disclaimer:</span> Niveza does not guarantee the accuracy or completeness of information on the site, nor does Niveza assume any liability for any loss that may result from reliance upon any such information or recommendations. Information and recommendations on the site are for general information only. Nothing contained herein is an offer to sell nor solicitation to buy any securities.
      </div>
    </div>
    <div className="nvz-footer-copyright">
      &copy; {new Date().getFullYear()} Niveza Inc. | All rights reserved.
    </div>
  </footer>
);

export default Footer;